import analyticstracker from "@jmc/analyticstracker";
import { useCookieInteraction } from "@jmc/core/src/hooks/useCookieInteraction/index";
import { EventTypes } from "@jmc/core/src/types/EventTypes";
import { useOnScreen } from "@jmc/utils/hooks/useOnScreen";
import { useScroll } from "@jmc/utils/hooks/useScroll";
import React, { useEffect, useRef } from "react";

export interface PropTypes {
    placement: string;
    children: React.ReactNode;
    name: string;
    position: number;
    title?: React.ReactNode;
    open?: boolean;
}

/**
 * Handles tracking on Tab components.
 * As we have no control on the click events we can only track the impression the tab content itself
 * The click events should be triggered on the Tab onChange
 */
const Content = ({ children, placement, name, position, open }: PropTypes): JSX.Element => {
    const { interacted } = useCookieInteraction();
    const ref = useRef<HTMLDivElement>(null);

    const inViewport = useOnScreen(ref);
    useEffect(() => {
        if (inViewport && interacted) {
            setTimeout(() => {
                analyticstracker().trackImpression(EventTypes.TAB_IMPRESSION);
            }, 1000);
        }
    }, [name, interacted, inViewport]);

    useScroll(() => {
        analyticstracker().trackImpression(EventTypes.TAB_IMPRESSION);
    }, 500);

    return (
        <div
            data-tracking-event={EventTypes.TAB_IMPRESSION}
            data-tracking-info={JSON.stringify({
                position,
                name,
                state: open ? "auto-visible" : "click-visible",
                placement,
            })}
            ref={ref}
        >
            {children}
        </div>
    );
};

export const TabImpression = (): null => null;

TabImpression.Content = Content;

export default TabImpression;
